export const environment = {
    apiUrl: 'https://rf0tdi4tm2.execute-api.us-east-1.amazonaws.com',
    kbapi_vi: 'https://app.test.studentsuccess.anthology.com/api/v1/',
    i18n: 'i18n/all?local=en_US',
    production: false,
    auth0: {
        domain: 'stdntsuccess-test.us.auth0.com',
        clientId: 'jdY5eMqdK3EMlTmiRuWm3ksyH7DIMmWH'
    },
    environment: 'test'
};
